module.exports = __webpack_public_path__ + "static/media/6.5d74624f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格选中态/6.png
// module id = 1278
// module chunks = 0